module.exports = __webpack_public_path__ + "static/media/skills.279b214e.svg";